import { Type } from '@angular/core';

/**
 * Non-local stub so production/staging/dev bundles never include the audit UI.
 * @returns Always null
 */
export async function loadTestAuditLogComponent(): Promise<Type<unknown> | null> {
  return null;
}
